<script>
import SectionCard from '../SectionCard.vue';

export default {
  name: 'GallerySection',
  components: { SectionCard },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <SectionCard section-id="gallery" :title="$t('REAL_ESTATE.GALLERY.TITLE')">
    <template #action>
      <woot-button
        variant="clear"
        size="small"
        icon="edit"
        @click="$emit('edit')"
      >
        {{ $t('REAL_ESTATE.GALLERY.EDIT_BUTTON') }}
      </woot-button>
    </template>

    <div
      v-if="project.gallery.length"
      class="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3"
    >
      <div
        v-for="image in project.gallery"
        :key="image.image_id"
        class="relative aspect-square rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700 bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400"
      >
        <fluent-icon icon="image" size="22" />
        <img
          :src="image.url"
          :alt="image.caption || ''"
          class="absolute inset-0 w-full h-full object-cover"
          @error="$event.target.remove()"
        />
        <span
          v-if="image.caption"
          class="absolute bottom-0 inset-x-0 bg-slate-900/70 text-white text-[10px] px-1.5 py-1 truncate"
        >
          {{ image.caption }}
        </span>
      </div>
    </div>
    <p v-else class="text-sm text-slate-400">
      {{ $t('REAL_ESTATE.GALLERY.EMPTY') }}
    </p>
    <p v-if="project.gallery.length" class="text-xs text-slate-400 mt-3">
      {{ project.gallery.length }} {{ $t('REAL_ESTATE.GALLERY.COUNT_NOTE') }}
    </p>
  </SectionCard>
</template>
